<template>
  <Modal
    :title="$t('announcement.modals.confirmDelete.title')"
    name="CONFIRM_DELETE_ANNOUNCEMENT"
    actions
  >
    <template v-slot:body>
      <h-loading v-if="isAnnouncementLoading" />

      <div v-if="!isAnnouncementLoading">
        <p class="body-2">
          {{ $t('announcement.modals.confirmDelete.text') }}
        </p>
        <v-card class="grey lighten-4 pa-5" elevation="0">
          <h6 class="text-uppercase grey--text">{{  $t('announcement.label.summary.title') }}</h6>
          <p class="body-2">{{ announcement.title }}</p>

          <h6 class="text-uppercase grey--text">{{  $t('announcement.label.summary.content') }}</h6>
          <v-card outlined>
            <iframe :srcdoc="announcement.content" width="100%" height="100%" frameborder="0" />
          </v-card>
        </v-card>
      </div>
    </template>

    <template v-slot:actions>
      <v-btn
        @click="closeModal('CONFIRM_DELETE_ANNOUNCEMENT')"
        :disabled="isDeletingAnnouncement"
        elevation="0"
        color="grey"
        large
        text
      >
        {{ $t('announcement.modals.confirmDelete.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="deleteAnnouncement(announcement.id)"
        :loading="isDeletingAnnouncement"
        color="primary"
        elevation="0"
        class="ml-5"
        large
        dark
      >
        {{ $t('announcement.modals.confirmDelete.buttons.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAnnouncementConfirmDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters([
      'announcement',
      'isAnnouncementLoading',
      'isDeletingAnnouncement',
    ]),
  },

  methods: {
    ...mapActions([
      'openModal',
      'closeModal',
      'deleteAnnouncement',
    ]),
  },
}
</script>
